import { render, staticRenderFns } from "./CTranslatorForm.vue?vue&type=template&id=542b504a&scoped=true&"
import script from "./CTranslatorForm.vue?vue&type=script&lang=js&"
export * from "./CTranslatorForm.vue?vue&type=script&lang=js&"
import style0 from "./CTranslatorForm.vue?vue&type=style&index=0&id=542b504a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b504a",
  null
  
)

export default component.exports